










import { Component, Mixins, Prop } from "vue-property-decorator";
import Enumerable from "linq";
import {
  NavigationPane,
  IImageSpecifiableButtonState,
} from "../../../panes";
import { ExternalMenuMixin } from "../../../system/mixins";
import ExternalMenuButton from "../../../system/ExternalMenuButton.vue";  // index.ts経由だと名前無しになるのでv-forで使えない
import {
  DocumentSummaryHistory,
  DocumentSummary,
} from "../../../../domain/document";
import { IExternalMenuItemConfiguration } from "../../../../domain/configuration";

@Component({
  components: {
    NavigationPane,
    ExternalMenuButton,
  },
})
export default class ExternalMenu extends Mixins(ExternalMenuMixin) {
  @Prop({ default: null })
  document: DocumentSummary;

  @Prop({ default: () => [] as IExternalMenuItemConfiguration[] })
  items: IExternalMenuItemConfiguration[];

  get buttons(): IImageSpecifiableButtonState[] {
    const source = this.createParameterSource();
    source.patientId = this.document ? this.document.patientNo : null;
    source.documentId = this.document ? this.document.id : null;

    return Enumerable.from(this.items)
      .select(menu => {
        const buttonState = this.toButtonState(menu, !this.document, source);
        if (!this.isVirtual) { return buttonState; }
        buttonState.isEnable = false;
        return buttonState;
      })
      .toArray();
  }

  get isVirtual(): boolean {
    return (this.document instanceof DocumentSummaryHistory || this.document instanceof DocumentSummary)
      && this.document.isVirtual;
  }
}
